import { CellStyleT } from 'ui/AgGridReact/colDefConfig';
import { ColDef } from 'ag-grid-community';
import { UserGroupSummaryT } from 'business/definitions';

const defaultCellStyleWithRightBorder: CellStyleT = {
    borderRight: '0.5px solid lightgray',
};
const cellStyleCentered: CellStyleT = {
    ...defaultCellStyleWithRightBorder,
    alignItems: 'center',
    display: 'flex',
    justifyContent: 'center',
    padding: '0px',
};

export const getColDefs = (
    userGroups: UserGroupSummaryT[],
    t: TranslationT,
): ColDef[] => [
    {
        field: 'name',
        cellStyle: defaultCellStyleWithRightBorder,
        headerName: t('adminSpace.userGroupsList.name'),
        flex: 4,
    },
    {
        cellStyle: cellStyleCentered,
        field: 'nbMembers',
        headerName: t('adminSpace.userGroupsList.nbMembers'),
        flex: 2,
    },
    {
        cellStyle: cellStyleCentered,
        field: 'nbSharedDashboards',
        headerName: t('adminSpace.userGroupsList.nbSharedDashboards'),
        flex: 2,
    },
    {
        cellStyle: cellStyleCentered,
        field: 'actions',
        headerName: t('common.actions'),
        flex: 1,
        cellRenderer: 'actionsCellRenderer',
        cellRendererParams: {
            existingGroupsNames: userGroups.map(
                (userGroup: UserGroupSummaryT) => userGroup.name,
            ),
        },
        valueGetter: ({ data }: { data: UserGroupSummaryT }) => data,
        sortable: false,
    },
];
